export default __webpack_public_path__ + "static/media/edit.c879ec31.svg";